//
//
//
//
//
//
//
//

import { QR_IMG, PREPAYMENT_CALC_LINK } from '../config'
import ResultIndex from '../share/result/index'
import share_mixins from '../share_mixins'
export default {
    mixins: [share_mixins],
    data() {
        return {
            prepayment_calc_link: PREPAYMENT_CALC_LINK,
            qr_img: QR_IMG
        }
    },
    components: {
        ResultIndex
    }
}
